export const truncateString = (value) => {
  const maxString = 100

  if (value.length <= maxString) {
    return value
  } else {
    return `${value.substring(0, maxString)}...`
  }
}
